import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Amplify from 'aws-amplify';
import '@aws-amplify/ui-vue';
import getAWSExports from './aws-exports';
import i18n from './i18n';
import attachCognitoModule from '@vuetify/vuex-cognito-module';
import dayjs from 'dayjs';

import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Europe/Berlin');

getAWSExports().then((awsExports) => {
  Amplify.configure(awsExports);
  Vue.config.productionTip = false;

  // cognito
  attachCognitoModule(
    store,
    {
      userPoolId: awsExports.Auth.userPoolId,
      identityPoolId: awsExports.identity_pool_id,
      userPoolWebClientId: awsExports.Auth.userPoolWebClientId,
      region: awsExports.aws_project_region
    },
    'cognito'
  );

  // cognito
  store.dispatch('cognito/fetchSession').finally(() => {
    store.commit('setIsSessionLoaded', true);
  });

  store.commit('setAWSExports', awsExports);

  new Vue({
    router,
    store,
    vuetify,
    i18n,
    render: (h) => h(App)
  }).$mount('#app');
});
